/**
 * Scroll reveal: fades and lifts text, cards and images into place as they
 * scroll into view. Scopes are `.reveal-on-scroll` (sections) and
 * `.reveal-items` (grids). Visual timing lives in config/styles.css.
 * Does nothing for visitors who prefer reduced motion. Elements already on
 * screen when the script runs are left visible, so nothing flashes.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion && 'IntersectionObserver' in window) {
  const TARGETS = 'h2, h3, p, blockquote, figure, li, a.inline-flex, img';

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const setup = () => {
    const viewportBottom = window.innerHeight;
    const scopes = document.querySelectorAll('.reveal-on-scroll, .reveal-items');

    for (const scope of scopes) {
      if (scope.hasAttribute('data-reveal-ready')) continue;
      scope.setAttribute('data-reveal-ready', '');

      const candidates = scope.classList.contains('reveal-items')
        ? Array.from(scope.children)
        : Array.from(scope.querySelectorAll(TARGETS));

      let index = 0;
      for (const el of candidates) {
        // Only the outermost match animates; nested text rides along with its card.
        if (el.parentElement && el.parentElement.closest('[data-reveal]')) continue;
        if (el.closest('[aria-hidden="true"]')) continue;
        // Never hide what the visitor can already see.
        if (el.getBoundingClientRect().top < viewportBottom) continue;

        el.style.setProperty('--reveal-index', String(index % 4));
        el.setAttribute('data-reveal', '');
        observer.observe(el);
        index += 1;
      }
    }
  };

  setup();
  // Canvas and live-filter updates can swap markup; tag new scopes as they appear.
  new MutationObserver(() => setup()).observe(document.body, { childList: true, subtree: true });
}
